import script from "./Brands.vue?vue&type=script&setup=true&lang=js"
export * from "./Brands.vue?vue&type=script&setup=true&lang=js"

import "./Brands.vue?vue&type=style&index=0&id=02e7644b&lang=scss"

const __exports__ = script;

export default __exports__